module.exports = __webpack_public_path__ + "img/6.1916c4d4.jpg";